import { render, staticRenderFns } from "./main.vue?vue&type=template&id=b9a83674&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9a83674')) {
      api.createRecord('b9a83674', component.options)
    } else {
      api.reload('b9a83674', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=b9a83674&", function () {
      api.rerender('b9a83674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/sales/main.vue"
export default component.exports